import React, {Dispatch, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import {WIZARD_CONFIG, WizardContext} from '../../steps';
import Button from '../../../../../incase-domain/components/button/Button';
import {useRoomsForPresentation} from '../../queries';
import {IPresentationMeta} from '../../../../../incase-domain/presentation';

interface ILiveEventConfigStepProps {
    presentation: IPresentationMeta;
    wizardContext: WizardContext;
    setWizardContext: Dispatch<SetStateAction<WizardContext>>;
    setCreateRoomModalOpen: Dispatch<SetStateAction<boolean>>;
}

function LiveEventStep({presentation, wizardContext, setWizardContext, setCreateRoomModalOpen}: ILiveEventConfigStepProps): JSX.Element {
    const {t} = useTranslation();

    const {data: rooms} = useRoomsForPresentation(presentation._id);

    const handleSelectRoom = (): void => {
        setWizardContext({...wizardContext, currentStep: WIZARD_CONFIG.LIVE_EVENT.options.ROOM_SELECTION});
    };

    const handleCreatedRoom = (): void => {
        setWizardContext({...wizardContext, currentStep: WIZARD_CONFIG.LIVE_EVENT.options.ROOM_CREATION});
        setCreateRoomModalOpen(true);
    };

    return (
        <>
            {rooms && rooms.length > 0 && (
                <Button onClick={handleSelectRoom} type="button" variant="ghost" color="info">
                    {t('caseWizard.liveEvent.selectRoom')}
                </Button>
            )}
            <Button onClick={handleCreatedRoom} type="button" variant="ghost" color="info">
                {t('caseWizard.liveEvent.createRoom')}
            </Button>
        </>
    );
}

export default LiveEventStep;
